import * as React from 'react'
import { ApolloConsumer } from 'react-apollo'

import {
  InitialParentSignUpForm,
  InitialParentSignUpFormSSO,
} from 'main/components/common/AuthModal'
import { AppContext } from 'main/framework'
import { CredentialsFields } from 'main/gql/credentials'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { login } from 'main/util/auth'
import { UserSignUpSource } from 'main/util/user'
import { ScheduleTourModal_school } from '../../ScheduleTourModal/common/gql'

interface IProps {
  school: ScheduleTourModal_school
  onRequestLogin: () => void
  onComplete: (credentials: CredentialsFields) => void
}

export default function SignUp(props: IProps) {
  const { school, onRequestLogin, onComplete } = props

  const appContext = React.useContext(AppContext)
  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  return (
    <ApolloConsumer>
      {client => {
        if (isSSO) {
          return (
            <InitialParentSignUpFormSSO
              googleOptimize={googleOptimize()}
              subtext="Create an account to schedule a tour"
              source={UserSignUpSource.ParentTourModal}
              segmentData={{
                event: 'New Parent Lead',
                data: { schoolId: school.id },
              }}
            />
          )
        } else {
          return (
            <InitialParentSignUpForm
              cta="Next: Select tour date and time"
              googleOptimize={googleOptimize()}
              source={UserSignUpSource.ParentTourModal}
              subtext="Create an account to schedule a tour"
              trackingData={{ schoolId: school.id }}
              onComplete={credentials => {
                login(client, credentials, appContext).then(() => onComplete(credentials))
              }}
              onRequestLogin={onRequestLogin}
            />
          )
        }
      }}
    </ApolloConsumer>
  )
}

function googleOptimize() {
  return {
    submitButton: 'scheduleTourSignUpSubmitButton',
    subtext: 'scheduleTourSignUpSubtext',
  }
}
